import { render } from "./ViewViolenceRow.vue?vue&type=template&id=4e48d201&scoped=true"
import script from "./ViewViolenceRow.vue?vue&type=script&lang=js"
export * from "./ViewViolenceRow.vue?vue&type=script&lang=js"

import "./ViewViolenceRow.vue?vue&type=style&index=0&id=4e48d201&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e48d201"

export default script